import script from "./AlentoursView.vue?vue&type=script&setup=true&lang=js"
export * from "./AlentoursView.vue?vue&type=script&setup=true&lang=js"

import "./AlentoursView.vue?vue&type=style&index=0&id=20f82e5a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20f82e5a"]])

export default __exports__